<template>
	<div style="width: 100%;">
		<!-- <iframe  
  ref="iframe"  
  :src="src" frameborder="0" 
  style="width:100%;height: 100%;">
 </iframe> -->
		<iframe width="100%" :src="src" frameborder="0" scrolling="no" id="test" :onload="reinitIframe"></iframe>

	</div>
</template>
<script>
export default {
	data() {
		return {
			id: this.$route.query.id,
			showSessiconId: '',
			src: '',
			timer: null
		}
	},
	// components:{ Page },
	methods: {
		reinitIframe() {
			var iframe = document.getElementById("test");
			try {
				var bHeight = iframe.contentWindow.document.body.scrollHeight;
				var dHeight = iframe.contentWindow.document.documentElement.scrollHeight; var height = Math.max(bHeight, dHeight);
				iframe.height = bHeight;
			}
			catch (ex) { }
		},
		getUrl() {
			let that = this
			let id = this.$route.query.id
			//根据id确认路径
			switch (id) {
				// 非凡十年
				case '1':
					that.src = 'static/ffsn.html'
					break;
				// 红色全景
				case '2':
					that.src = 'static/dz_overall_new.html'
					break;
				// 德育专题
				case '3':
					that.src = 'static/dyztlist.html?page=1&name=中国传统文化'
					break;
				//复兴文库
				case '4':
					that.src = 'static/sz_fxwk.html'
					break;
				// 百年党史
				case '5':
					that.src = 'static/bnds.html'
					break;
				// 思政课程高中版
				case '6':
					that.src = 'static/szkc_home.html'
					break;
				// 思政课程大学版
				case '7':
					that.src = 'static/szkc_home_dx.html'
					break;
				// 学习阅读
				case '8':
					that.src = 'static/xxyd.html'
					break;
				//思政工作室
				case '9':
					that.src = 'static/ssgzs.html'
					break;
				// 四史教育
				case '10':
					that.src = 'static/ss_list.html?zid=0&tid=0&lid=2&per_page=1&type=8'
					break;
				// 知识图谱
				case '11':
					that.src = 'static/szindex.html'
					break;
				// 课程思政
				case '12':
					that.src = 'static/xksj.html'
					break;
				// 课程思政详情
				case '18':
					that.src = 'static/xksjlist.html?id=' + this.$route.query.zyid
					break;
				// 本校资源
				case '13':
					that.src = 'static/bxzy.html'
					break;
				// 本校资源详情
				case '16':
					that.src = 'static/sfk_play1.html?id=' + this.$route.query.zyid
					break;
				// 高中读本
				case '14':
					that.src = 'static/szkc_sy_detail.html?index=4&id=5&name=习近平新时代中国特色社会主义思想&bigTitle=思想政治理论课'
					break;
				// 高校党建
				case '15':
					that.src = 'static/gxdj.html'
					break;
				// 师资培训详情
				case '17':
					that.src = 'static/szpxspecialDetail.html?id=' + this.$route.query.szid
					break;
				// 搜索思政课程详情
				case '19':
					that.src = 'static/szkc_video.html?id=' + this.$route.query.zyid + "&bsid=" + this.$route.query.bsid;
					break;
				//筑牢中华民族共同体意识
				case '20':
					that.src = 'static/xlgl_gtys.html'
					break;
				// 校本资源列表
				case '21':
					that.src = "static/xbzy_detail.html?index=" + 10 + "&page=1&level=0&bsid=0&mid2=0&mid3=0&mid=" + this.$route.query.mid;
					break;
				// 精品课程详情
				case '22':
				that.src = 'static/jpkc_detail.html?id='+ this.$route.query.zyid+'&title='+this.$route.query.title
				break;

			}


		}
	},


	mounted() {
		this.getUrl()
		if (this.timer == null) {
			this.timer = setInterval(() => {
				var iframe = document.getElementById("test");
				try {
					var bHeight = iframe.contentWindow.document.body.scrollHeight;
					var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
					var height = Math.max(bHeight, dHeight);
					iframe.height = bHeight;

				} catch (ex) { }

			}, 500)
		}
	},
	created() {
		if (this.$route.query.id == 9) {
			this.$emit("highLight", 8, "", "", "");
		} else if (this.$route.query.id == 11) {
			this.$emit("highLight", 2, "", "", "");
		} else if (this.$route.query.id == 12) {
			this.$emit("highLight", 3, "", "", "");
		} else if (this.$route.query.id == 13) {
			this.$emit("highLight", 10, "", "", "");
		}
		else if (this.$route.query.id == 7 || this.$route.query.id == 6) {
			this.$emit("highLight", 4, "", "", "");
		}
		else if (this.$route.query.id == 17) {
			this.$emit("highLight", 7, "", "", "");
		}
		else if (this.$route.query.id == 3 || this.$route.query.id == 14) {
			this.$emit("highLight", 5, "", "", "");
		}

		else {
			this.$emit("highLight", 0, "", "", "");
		}

	},
	beforeDestroy() {
		//清除定时器
		clearInterval(this.timer);
		this.timer = null;
	},
	watch: {

	},
}
</script> 

<style scoped></style>
